<template>
  <div style="display:inline-block;">
      <el-button @click="showDialog">导出</el-button>

        <el-dialog
            title="导出工单"
            :visible.sync="dialogVisible"
            width="40vw">
            <el-form label-width="50px">
                <el-form-item label="表单">
                    <el-switch v-model="withForm" inactive-text="仅导出工单本身数据" active-text="导出工单数据 + 工单内表单数据"/>
                </el-form-item>

                <el-form-item label="格式">
                    <el-button @click="doExport('csv')">CSV</el-button>
                    <el-button @click="doExport('xls')">XLS</el-button>
                    <el-button @click="doExport('xlsx')">XLSX</el-button>
                    <el-button @click="doExport('doc')">DOC</el-button>
                    <el-button @click="doExport('docx')">DOCX</el-button>
                    <el-button @click="doExport('pdf')">PDF</el-button>
                </el-form-item>
            </el-form>

            <div slot="footer" style="height:25px;"/>
        </el-dialog>
  </div>
</template>

<script>
export default {
    name: 'TicketExportButton',

    data() {
        return {
            withForm: false,
            dialogVisible: false
        };
    },

    methods: {
        showDialog() {
            this.dialogVisible = true;
        },

        doExport( _command ) {
            if(!confirm("导出过程可能会消耗一些时间, 如遇到问题, 可重试几次, 或联系技术人员; 确定要导出?")) {
                return;
            }

            var _this = this;

            this.$emit('export', {
                withForm: _this.withForm,
                type: _command
            });
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketExportButton.vue